module.exports = __webpack_public_path__ + "img/nace.cae98861.png";